<div class="modal-header">
    <div class="row col-12">
        <div class="modal-title col-10">
            <h5>Udvidet Tekst</h5>
        </div>

        <div class="text-end col-2">
            <button type="button" class="btn" aria-label="Close" (click)="activeModal.dismiss()">
                <span aria-hidden="true"><i class="fa-solid fa-x"></i></span>
            </button>
        </div>
    </div>
</div>
<div class="modal-body">
    <div class="d-flex">
        <div class="mb-3 flex-grow-1">
            <textarea [attr.lang]="language" style="field-sizing: content;" type="text" class="form-control" id="editableTextbox" [(ngModel)]="text" [readOnly]="readonly"></textarea>
        </div>
    </div>
</div>
<div class="modal-footer">
    @if(!readonly) {
    <button type="button" class="btn btn-secondary" data-bs-dismiss="modal"
        (click)="activeModal.dismiss('Cross click')">Annuller</button>
    <button type="button" class="btn btn-primary" (click)="accept()">Accepter</button>
    }
</div>